module.exports = " <div id=app class=container-fluid> <loader v-if=!hasData></loader> <controls v-if=hasData></controls> <hints></hints> <tweet v-if=hasData></tweet> <infobar v-if=hasData></infobar> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 55
 ** module chunks = 2
 **/